var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgOpenTelemetry = function SvgOpenTelemetry(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#open_telemetry_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#f5a800",
    d: "M10.57 10.906a2.1 2.1 0 1 0 2.97 2.97 2.1 2.1 0 0 0-2.97-2.97m2.22 2.22a1.04 1.04 0 0 1-1.47 0 1.04 1.04 0 0 1 0-1.47 1.04 1.04 0 0 1 1.47 0 1.04 1.04 0 0 1 0 1.47M13.505.574l-1.287 1.287a.65.65 0 0 0 0 .918l5.023 5.023a.65.65 0 0 0 .918 0l1.287-1.287a.65.65 0 0 0 0-.918L14.422.574a.65.65 0 0 0-.917 0M4.49 17.015a.59.59 0 0 0 0-.83l-.654-.654a.59.59 0 0 0-.83 0l-1.35 1.351-.002.002-.37-.371a.524.524 0 1 0-.742.742l2.226 2.226a.524.524 0 0 0 .742 0 .526.526 0 0 0 0-.742l-.371-.371.002-.002Zm0 0"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#425cc7",
    d: "M11.296 4.268 8.438 7.126a.66.66 0 0 0 0 .926l1.765 1.765a3.19 3.19 0 0 1 4.119.336l1.43-1.43a.66.66 0 0 0 0-.926l-3.53-3.529a.654.654 0 0 0-.926 0M9.462 10.56 8.419 9.517a.63.63 0 0 0-.888 0l-3.677 3.678a.63.63 0 0 0 0 .888l2.083 2.083a.63.63 0 0 0 .888 0l2.365-2.368c-.5-1.033-.41-2.28.271-3.237Zm0 0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "open_telemetry_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h20v20H0z"
  })))));
};
export default SvgOpenTelemetry;